import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { IFilter } from "../../../../types/filter.type";
import FilterText from "../FilterText";

function FilterCRNhomthuoc({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    nhomthuoc: "",
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterText
        label="Tên nhóm thuốc"
        placeholder="Tìm theo tên nhóm thuốc"
        defaultValue={filter.nhomthuoc}
        onChange={(val) => setFilter({ ...filter, nhomthuoc: val })}
      />
    </Stack>
  );
}

export default FilterCRNhomthuoc;
